import { render } from "./UniqueAsYouMobile.vue?vue&type=template&id=4ca2b379&scoped=true"
import script from "./UniqueAsYouMobile.vue?vue&type=script&lang=js"
export * from "./UniqueAsYouMobile.vue?vue&type=script&lang=js"

import "./UniqueAsYouMobile.vue?vue&type=style&index=0&id=4ca2b379&lang=sass&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4ca2b379"]])

export default __exports__